module.exports = __webpack_public_path__ + "assets/img/Cancel_btn.240365f0.png";